export const environment = {
  production: false,
  apiUrl: "https://uat-api.nightweb.noveltytechnology.com/api/web"
};
